import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import FullPageBackgroundContainer from "../../component/FullPageBackgroundContainer";
import NavigationBar from "../../component/NavigationBar";
const useStyles = makeStyles((theme) => ({
  recruitBox: {
    position: "absolute",

    top: "20%",
    left: "5%",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
      textAlign: "center",
      top: "30%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    [theme.breakpoints.down("s")]: {
      position: "none",
      margin: "auto",
      marginTop: "30px",
      zIndex: -1,
      width: "100%",
      padding: "0 15px",
    },
  },
  recruitBody: {
    width: "45%",
    marginBottom: "20px",
    [theme.breakpoints.between("md", "md")]: {
      width: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  recruitTitle: {
    marginBottom: "60px",
    [theme.breakpoints.between("md", "md")]: {
      marginBottom: "45px",
    },
    [theme.breakpoints.down("s")]: {
      marginBottom: "20px",
    },
  },
  recruitSubtitle: {
    marginBottom: "30px",
  },
  recruitButton: {
    borderRadius: "25px",
    padding: "5px 24px",
  },
}));
export default function Shopping() {
  const classes = useStyles();

  return (
    <FullPageBackgroundContainer background="shopPage--background">
      <NavigationBar />
      <Box className={classes.recruitBox}>
        <Typography
          variant="h1"
          color="primary"
          className={classes.recruitTitle}
        >
          オンライン発注
        </Typography>

        <Typography variant="body1" className={classes.recruitBody}>
          レストラン・飲食店をはじめとして、各種外食産業様、病院・学校給食事業者様等の業務用の食材をご利用になられるお客様へ。必要なものを必要なだけ、必要な時にお届けします。
        </Typography>
        <Button
          className={classes.recruitButton}
          variant="contained"
          color="primary"
          href="https://www2.infomart.co.jp/oroshi/index.pagex?0&oroshi_smcd=SNJoFpZ5"
        >
          詳細
        </Button>
      </Box>
    </FullPageBackgroundContainer>
  );
}
